import { Box, Modal } from "@mui/material";
import UBButton from "../UBButton";
import { CloseIcon } from "./../../assets/icons/icon";
import HeadingText from "../HeadingText";
import styles from "./styles.module.css";
import ParagraphText from "../ParagraphText";
import { LanguageContext } from "../../context/LanguageContext";
import { useContext } from "react";

const UBAppModal = ({
  children,
  header,
  footer,
  open,
  className,
  backdropClassName,
  centered = true,
  fullScreen,
  disableContainerScroll = false,
  id = "",
  ...rest
}) => {
  const { handleClose, CustomHeader, title,dont_show_cross_icon } = header || {};
  const [I18n] = useContext(LanguageContext);

  return (
    <Modal
      open={!!open}
      onClose={handleClose}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          },
        },
      }}
      id={id}
      {...rest}
    >
      <Box
        className={`${styles.modalContainer} ${
          fullScreen ? "fullscreenContainer" : ""
        } ${className ?? ""}`}
        sx={{
          position: "absolute",
          top: centered ? "50%" : "auto",
          left: centered ? "50%" : "auto",
          transform: centered ? "translate(-50%, -50%)" : "none",
          outline: "none",
          maxHeight: "90vh",
          overflow: disableContainerScroll ? "hidden" : "auto",
        }}
      >
      {CustomHeader ? (
        CustomHeader
      ) : (
        <div className="HeaderModal">
          {title ? (
            <div className="modalTitle" id={`${id}_title`}>              
              {typeof title === "string" ? (
                <HeadingText
                  className={
                    "fontSize20 fontWeight500 newFontColor textCapitalizeFirstLetter"
                  }
                >
                  {I18n[title]}
                </HeadingText>
              ) : (
                title
              )}
            </div>
          ) : null}
          {typeof handleClose === "function" && title && !dont_show_cross_icon && (
            <ParagraphText
              className="modalclose"
              id={`${id}_UB_modal_close`}
              onClick={handleClose}
            >
              <CloseIcon />
            </ParagraphText>
          )}
        </div>
      )}
      <div className={`bodyModal ${styles.bodyModal}`}>{children}</div>
      {footer?.length ? (
        <div className={`${styles.footerModal} footerModal footer`}>
          {footer.map((item, index) => {
            const { data } = item || {};
            return (
              <UBButton
                disabled={Boolean(data.disabled)}
                className={data?.className}
                style={data?.style ?? {}}
                onClick={data?.onClick}
                loading={data?.loading}
                title={data?.title}
                type={data.type}
                form={data?.form}
                index={index}
                key={index}
                id={`${data?.id}_BtnId`}
              />
            );
          })}
        </div>
      ) : null}
      </Box>
    </Modal>
  );
};

export default UBAppModal;
